// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1NjQW","content":"styles_content__2Fs1y","selectAll":"styles_selectAll__yUZm-"};